import React from 'react'
import { cn } from '@/lib/utils'

/** Inline validation message matching the Field component's error line. */
const FieldError = ({ message, className }: { message?: string; className?: string }) =>
  message ? (
    <p
      role="alert"
      className={cn(
        'mt-1.5 text-[12px] font-medium leading-[1.4] tracking-[-0.2px] text-[#D33] animate-lc-fade-up',
        className
      )}
    >
      {message}
    </p>
  ) : null

export default FieldError
